// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Belt_Map = require("bs-platform/lib/js/belt_Map.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_MapString = require("bs-platform/lib/js/belt_MapString.js");

function groupByString(values, getKey) {
  return Belt_List.reduceReverse(values, Belt_MapString.empty, (function (accMap, nextVal) {
                return Belt_MapString.update(accMap, Curry._1(getKey, nextVal), (function (existingVals) {
                              if (existingVals !== undefined) {
                                return /* :: */[
                                        nextVal,
                                        existingVals
                                      ];
                              } else {
                                return /* :: */[
                                        nextVal,
                                        /* [] */0
                                      ];
                              }
                            }));
              }));
}

function groupBy(values, id, getKey) {
  return Belt_List.reduceReverse(values, Belt_Map.make(id), (function (accMap, nextVal) {
                return Belt_Map.update(accMap, Curry._1(getKey, nextVal), (function (existingVals) {
                              if (existingVals !== undefined) {
                                return /* :: */[
                                        nextVal,
                                        existingVals
                                      ];
                              } else {
                                return /* :: */[
                                        nextVal,
                                        /* [] */0
                                      ];
                              }
                            }));
              }));
}

exports.groupByString = groupByString;
exports.groupBy = groupBy;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ../belt-holes/src/BeltHoles_List.bs.js
// module id = 563
// module chunks = 0